import Link from "next/link"
import classNames from "classnames"
import { ReactNode } from "react"
import { each, map, mapValues, orderBy } from "lodash"
import { getPlayerPageUrl, getTeamPageUrl } from "../../../utils/urls"
import { LocalizedPlayer } from "types/player"
import { LocalizedPlayerTeamComparisonStats } from "types/playerTeamComparisonStats"

export function PlayerTeamComparisonStats({
  stats,
  player,
}: {
  stats: LocalizedPlayerTeamComparisonStats
  player: LocalizedPlayer
}) {
  const rows: ReactNode[] = []

  const orderedStatsByCountry = mapValues(stats, (countryStats) => {
    return orderBy(Object.values(countryStats), ["count"], ["desc"])
  })

  const orderedStats = orderBy(Object.values(orderedStatsByCountry), ["[0].count"], ["desc"])

  each(orderedStats, (countryStats) => {
    let addCountry = true
    each(countryStats, (obj) => {
      const { country, team, count, win, lost, draw, red, yellow, yellowRed, goal } = obj
      if (addCountry) {
        addCountry = false
        rows.push(
          <tr className="country-table-header">
            <th className="team-name team-name-">{country.name}</th>
            <th className="standing-games_played standing-games_played-">PG</th>
            <th className="standing-win standing-win-">V</th>
            <th className="standing-draw standing-draw-">P</th>
            <th className="standing-lost standing-lost-">S</th>
            <th className="standing-goaldiff standing-goaldiff-">
              <img src="/event_icons/goal.png" />
            </th>
            <th className="standing-goaldiff standing-goaldiff-">
              <img src="/event_icons/yellow.png" />
            </th>
            <th className="standing-goaldiff standing-goaldiff-">
              <img src="/event_icons/yellow-red.png" />
            </th>
            <th className="standing-goaldiff standing-goaldiff-">
              <img src="/event_icons/red.png" />
            </th>
          </tr>,
        )
      }
      const index = rows.length
      const isOdd = (index + 1) % 2 === 1

      const url = getTeamPageUrl(team.calciocomSlug!) //getPlayerPageUrl(player.calciocomSlug, "bilancio", team.calciocomSlug)

      rows.push(
        <tr
          key={country.id + "-" + team.id}
          className={classNames("standing standing-" + (index + 1), index === 0 && "first", isOdd ? "odd" : "even")}
        >
          <td className="team-name team-name-">
            <Link href={url}>
              <a title={team.name}>{team.name}</a>
            </Link>
          </td>
          <td className="standing-games_played">{count}</td>
          <td className="standing-win">{win}</td>
          <td className="standing-draw">{draw}</td>
          <td className="standing-lost">{lost}</td>
          <td className="standing-goaldiff">{goal}</td>
          <td className="standing-goaldiff">{yellow}</td>
          <td className="standing-goaldiff">{yellowRed}</td>
          <td className="standing-goaldiff">{red}</td>
        </tr>,
      )
    })
  })

  return (
    <div className="hs-block hs-standing">
      {/*<h2 className="hs-block-header">Bilancio {mainTeam.name} contro...</h2>*/}
      <div className="module-standing">
        <table data-sort="points">
          <tbody>{rows}</tbody>
        </table>
      </div>
    </div>
  )
}
